// extracted by mini-css-extract-plugin
export default {"root":"IconRemove_root__KsGAk"};